import React from 'react';
import { useSpring, animated } from '@react-spring/web';

type SlideProps = {
  content: React.ReactNode;
  offsetRadius: number;
  index: number;
  animationConfig: {
    tension: number;
    friction: number;
  };
  moveSlide: (direction: number) => void;
  delta?: [number, number];
  down?: boolean;
  up?: boolean;
};

const Slide: React.FC<SlideProps> = ({
  content,
  offsetRadius,
  index,
  animationConfig,
  moveSlide,
  delta = [0, 0],
  down = false,
}) => {
  const offsetFromMiddle = index - offsetRadius;
  const totalPresentables = 2 * offsetRadius + 1;
  const distanceFactor = 1 - Math.abs(offsetFromMiddle / (offsetRadius + 3));

  const translateXOffset = Math.abs(offsetFromMiddle) / (offsetRadius + 1);
  let translateX = -50;

  if (offsetRadius !== 0) {
    if (index === 0) {
      translateX = 0;
    } else if (index === totalPresentables - 1) {
      translateX = -100;
    }
  }

  if (offsetFromMiddle === 0 && down) {
    translateX += delta[0] / (offsetRadius + 1);
    if (translateX > -40) moveSlide(-1);
    if (translateX < -100) moveSlide(1);
  }

  if (offsetFromMiddle > 0) {
    translateX += translateXOffset;
  } else if (offsetFromMiddle < 0) {
    translateX -= translateXOffset;
  }

  const springStyle = useSpring({
    to: {
      transform: `translateY(0%) translateX(${translateX}%) scale(${distanceFactor})`,
      left: `${offsetRadius === 0 ? 50 : 50 + (offsetFromMiddle * 50) / offsetRadius}%`,
      // opacity: distanceFactor * distanceFactor
    },
    config: animationConfig,
  });

  return (
    <animated.div
      className="slide"
      style={{
        ...springStyle,
        zIndex: Math.abs(Math.abs(offsetFromMiddle) - 2),
      }}
    >
      <div className="slide-card" onClick={() => moveSlide(offsetFromMiddle)}>
        {content}
      </div>
    </animated.div>
  );
};

export default Slide;
